import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { allTagTypes } from "./helpers/tags.js";
import { handleSessionExpiredResponse } from "./sessionExpiry.js";
import { apiBaseUrl, getApiAuthorizationHeaderValue } from "./shared.js";

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  prepareHeaders: async (headers) => {
    const authorization = await getApiAuthorizationHeaderValue();
    headers.set("Authorization", authorization);
    headers.set("x-alpharun-commit-sha", __COMMIT_SHA__);
  },
  // Our custom serializer supports array parameters by repeating the parameter
  paramsSerializer(params) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        for (const v of value) {
          searchParams.append(key, v);
        }
      } else if (value !== undefined) {
        searchParams.append(key, value);
      }
    }

    return searchParams.toString();
  },
});

/** Sends an expired session back through sign-in, from any endpoint. */
const baseQueryWithSessionExpiry: typeof baseQuery = async (
  args,
  queryApi,
  extraOptions,
) => {
  const result = await baseQuery(args, queryApi, extraOptions);
  if (result.error) {
    handleSessionExpiredResponse(result.error.status, result.error.data);
  }
  return result;
};

// https://redux-toolkit.js.org/rtk-query/usage/code-splitting
export const api = createApi({
  baseQuery: baseQueryWithSessionExpiry,
  // TODO: Use enhanceEndpoints to dynamically load tags/caching.
  tagTypes: allTagTypes,
  endpoints: (builder) => ({}),
});
